import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API, axios } from '../utils/api';
import { salvaBlob } from '../utils/documenti';
import './condivisi.css';

// Link protetto per banca e notaio (/condivisi/:token). Il token vale per una sola apertura: diventa una sessione
// per questo browser (salvata qui), che vale fino alla scadenza. Nessun login, nessun allegato nelle email.

const chiave = (token) => `mk-condiviso-${token.slice(0, 16)}`;
const leggi = (token) => { try { return localStorage.getItem(chiave(token)); } catch { return null; } };
const salva = (token, sessione) => { try { localStorage.setItem(chiave(token), sessione); } catch { /* navigazione privata */ } };
const peso = (byte) => (byte ? (byte > 1024 * 1024 ? `${(byte / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(byte / 1024))} KB`) : '');
const giorno = (valore) => {
  const d = new Date(typeof valore === 'string' && !/[zZ]|[+-]\d\d:?\d\d$/.test(valore) ? `${valore}Z` : valore);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
};

const Condivisi = () => {
  const { token } = useParams();
  const [dati, setDati] = useState(null);
  const [errore, setErrore] = useState(null);
  const [attesa, setAttesa] = useState(null);

  useEffect(() => {
    const sessione = leggi(token);
    axios.post(`${API}/condivisi/${token}/apri`, {}, { headers: sessione ? { 'X-Sessione': sessione } : {} })
      .then((r) => { salva(token, r.data.sessione); setDati(r.data); })
      .catch((e) => setErrore(e.response?.data?.detail || 'Link non valido.'));
  }, [token]);

  const scarica = async (percorso, nome, id) => {
    setAttesa(id);
    try {
      const r = await axios.get(`${API}/condivisi/${percorso}`, { headers: { 'X-Sessione': dati.sessione }, responseType: 'blob' });
      salvaBlob(r.data, nome);
    } catch (e) {
      setErrore(e.response?.status === 410 ? 'Il link è scaduto: chiedete a MK Consulting di inviarlo di nuovo.' : 'Download non riuscito. Riprovate.');
    } finally { setAttesa(null); }
  };

  return (
    <div className="mk-condivisi">
      <div className="wrap">
        <div className="brand"><img src="/mk_logo_original.png" alt="" />MK<i>.</i>Consulting</div>
        {errore && <><h1>Documenti non disponibili</h1><p className="err">{errore}</p></>}
        {!errore && !dati && <p>Apro i documenti…</p>}
        {!errore && dati && (
          <>
            <h1>Documenti per <em>{dati.ente}</em></h1>
            <p>Pratica di {dati.cliente} · il link scade il {giorno(dati.scade)}</p>
            {dati.messaggio && <div className="messaggio">{dati.messaggio}</div>}
            <div className="card">
              {dati.documenti.map((d) => (
                <div className="riga" key={d.id}>
                  <div><b>{d.tipo}</b><span>{d.nome} · {peso(d.size)}</span></div>
                  <button type="button" disabled={attesa === d.id} onClick={() => scarica(`documenti/${d.id}`, d.nome, d.id)}>Scarica</button>
                </div>
              ))}
            </div>
            <div className="azioni">
              <p>{dati.documenti.length} documenti</p>
              {dati.documenti.length > 1 && (
                <button type="button" className="p" disabled={attesa === 'zip'} onClick={() => scarica('zip', 'documenti.zip', 'zip')}>Scarica tutto (zip)</button>
              )}
            </div>
            <small>Link personale: si apre solo da questo dispositivo. Ogni apertura e ogni download vengono registrati.</small>
          </>
        )}
      </div>
    </div>
  );
};

export default Condivisi;
